import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { GridModule } from '@syncfusion/ej2-ng-grids';

import { AppComponent } from './app.component';

import { ContentComponent } from './content/content.component';
import { InvalidConfigurationKeyComponent } from './invalid-configurationkey/invalid-configurationkey.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

import { PharmacyLocatorService } from '../services/pharmacy-locator/pharmacy-locator.service';
import { MedispanService } from '../services/medispan/medispan.service';

import { SharedModule } from '../lib/shared/shared.module';

import { LoaderService } from '../lib/services/loader.service';
import { ServiceProxy } from '../lib/services/service-proxy.service';
import { ExternalDependencyLoader } from '../lib/services/external-dependency-loader.service';
import { ServicesModule } from '../lib/services/services.module';
import { ConcreteServicesModule } from '../services/concrete-services.module';
import { ConsoleLogger } from '../lib/services/console-logger.service';

import { LoggerService } from '../lib/services/logger';

import { ServiceProxyBase } from '../lib/services/service-proxy-base';
import { PharmacyLocatorGateway } from '../lib/services/pharmacy-locator-gateway';
import { PharmacyLookupModule } from '../widgets/pharmacy-lookup/pharmacy-lookup.module';
import { LocatorModule } from '../widgets/locator/locator.module';
import { MapModule } from '../widgets/map/map.module';
import { AppSettingsService } from '../lib/services/app-settings.service';
import { SettingsService } from '../lib/services/settings';
import { PharmacyLocatorComponent } from './pharmacy-locator/pharmacy-locator.component';
import { DrugSearchComponent } from './drug-search/drug-search.component';
import { PharmacyLocatorModule } from './pharmacy-locator/pharmacy-locator.module';
import { DrugSearchModule } from './drug-search/drug-search.module';
import { ApplicationInsightsLogger } from '../lib/shared/applicationinsights-logger';


const appRoutes: Routes = [
    { path: 'PharmacyLocator/:clientId', component: PharmacyLocatorComponent },
    { path: 'DrugPricing/:clientId', component: DrugSearchComponent },
    { path: 'InvalidAccessToken', component: InvalidConfigurationKeyComponent },
    { path: '**', component: PageNotFoundComponent }
];

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        GridModule,
        RouterModule.forRoot(appRoutes),
        DrugSearchModule,
        PharmacyLocatorModule,
        SharedModule,
        ServicesModule.forRoot(),
        ConcreteServicesModule.forRoot(),
        LocatorModule.forRoot(),
        MapModule.forRoot(),
        PharmacyLookupModule.forRoot()
    ],
    declarations: [
        AppComponent,
        ContentComponent,
        InvalidConfigurationKeyComponent,
        PageNotFoundComponent
    ],
    exports: [ ],
    providers: [
        PharmacyLocatorGateway,
        PharmacyLocatorService,
        MedispanService,
        ExternalDependencyLoader,
        { provide: ServiceProxyBase, useClass: ServiceProxy },
        { provide: LoggerService, useClass: ConsoleLogger },
        { provide: SettingsService, useClass: AppSettingsService },
        LoaderService,
        ApplicationInsightsLogger
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(private pharmacyLocatorGateway: PharmacyLocatorGateway) {
        this.pharmacyLocatorGateway.initialize();
    }
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/app/app.module.ts